var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConflictWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19.9975,
    height: 18.5015,
    viewBox: "0 0 19.9975 18.5015",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.9973 14.5019C10.9973 13.9504 10.5502 13.5033 9.99866 13.5033C9.44712 13.5033 9 13.9504 9 14.5019C9 15.0535 9.44712 15.5006 9.99866 15.5006C10.5502 15.5006 10.9973 15.0535 10.9973 14.5019ZM10.7381 6.64865C10.6882 6.28261 10.3742 6.00071 9.99446 6.00102C9.58025 6.00135 9.24473 6.3374 9.24506 6.75162L9.24866 11.2532L9.25559 11.355C9.30555 11.721 9.61957 12.0029 9.99926 12.0026C10.4135 12.0023 10.749 11.6662 10.7487 11.252L10.7451 6.75042L10.7381 6.64865ZM11.9673 1.16083C11.1111 -0.386963 8.88589 -0.386943 8.02967 1.16088L0.284384 15.1624C-0.545175 16.662 0.53945 18.5015 2.25323 18.5015H17.7443C19.4581 18.5015 20.5427 16.6619 19.7131 15.1623L11.9673 1.16083ZM9.34223 1.88696C9.62764 1.37102 10.3694 1.37101 10.6548 1.88695L18.4005 15.8884C18.6771 16.3883 18.3155 17.0015 17.7443 17.0015H2.25323C1.68196 17.0015 1.32043 16.3883 1.59694 15.8884L9.34223 1.88696Z",
    fill: "#A4262C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflictWarning);
export default __webpack_public_path__ + "static/media/conflict-warning.711186eb329587c67f3079de16558dfa.svg";
export { ForwardRef as ReactComponent };